export default "__VITE_ASSET__41b94c95__"